import { createApiClient } from "@mbits/mray-react-common";

export const { apiClient, setAccessToken } = createApiClient();
